var IS_PROD_ENV = process.env.NODE_ENV === 'production';
export var invariant = function invariant(condition, errMsg) {
  if (!IS_PROD_ENV && errMsg === undefined) {
    throw new Error('Invariant requires an error message argument.');
  }

  if (!condition) {
    var finalErrorMessage = IS_PROD_ENV || errMsg === undefined ? 'Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.' : "Invariant Violation: " + errMsg;
    throw new Error(finalErrorMessage);
  }
};